import { TextLink } from '@edsn/pie-components';
import { useTranslation } from 'react-i18next';
import type { KnowledgeArticleListDto } from '#pie/internal/api/pie-bff';
import { Card } from '../card/Card';
import { SkeletonLines } from '../skeleton-lines/SkeletonLines';
import { Stack } from '../stack/Stack';
import { Text } from '../text/Text';

type RelatedKnowledgeArticlesCardProps = {
  isLoading?: boolean;
  articles?: KnowledgeArticleListDto[];
};

export const RelatedKnowledgeArticlesCard = ({
  articles = [],
  isLoading,
}: RelatedKnowledgeArticlesCardProps) => {
  const { t } = useTranslation();
  return (
    <Card
      heading={
        <Text as="h6" variant="h6">
          {t('common.related.knowledge_articles')}
        </Text>
      }
      size="md"
      className="bg-transparent"
    >
      <Stack gap="md" divider="line">
        {isLoading ? (
          <SkeletonLines lines={3} />
        ) : (
          <>
            {articles.length === 0 && (
              <Text>{t('common.related.no_results')}</Text>
            )}
            {articles.map((article) => (
              <Stack
                as="article"
                key={article.id}
                gap="xs"
                className="items-start"
              >
                <Stack divider="dot" direction="row" gap="sm" key={article.id}>
                  <Text>{article.articlePublicNumber}</Text>
                  {article.mainCategory && (
                    <Text>{article.mainCategory.label}</Text>
                  )}
                </Stack>
                <TextLink
                  href={`/kennisbank/${article.id}`}
                  target="_blank"
                  className="whitespace-normal"
                >
                  {article.title}
                </TextLink>
              </Stack>
            ))}
          </>
        )}
      </Stack>
    </Card>
  );
};
